import { cookieHelper } from "./cookie-helper";

export const fetchWrapper = {
    get,
    post,
    put,
    delete: _delete
};

const baseUrl = process.env.REACT_APP_USER_MANAGER;

async function validate_token() {
    if (cookieHelper.getAuthToken()) {
        await checkAccessToken();
    }
}

async function get(url) {
    await validate_token();
    
    const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': cookieHelper.getAuthToken()
        } 
    };
    return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(handleError);
}

async function post(url, body, useRefresh=false) {
    await validate_token();
    let authToken = useRefresh ? cookieHelper.getRefreshToken() : cookieHelper.getAuthToken();
    return await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify(body)
    })
    .then(handleResponse)
    .catch(handleError);
}

async function put(url, body) {
    await validate_token();

    const requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': cookieHelper.getAuthToken()
        },
        body: JSON.stringify(body)
    };

    return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(handleError);
}

// prefixed with underscored because delete is a reserved word in javascript
async function _delete(url, body) {
    await validate_token();

    const requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': cookieHelper.getAuthToken()
        },
        body: JSON.stringify(body)
    };

    return fetch(url, requestOptions)
    .then(handleResponse)
    .catch(handleError);
}

// helper functions

async function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            try{
                const error = (data.message) || (data.errors[0]);
                return Promise.reject(error);
            }
            catch (error){
                return Promise.reject('Server error.');
            }
        }

        return data;
    });
}

async function handleError(error) {
    if ( typeof error === 'object') {
        if (error.detail) {
            return Promise.reject(error.detail);
        }
    }
    return Promise.reject(error);
}

async function checkAccessToken() {
    let url = `${baseUrl}/validate_token`;
    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': cookieHelper.getAuthToken()
        }
    }
    let response = await fetch(url, requestOptions).catch((error) => {
        return new Response(JSON.stringify({ errors: ['Failed to fetch.'] }), {
            status: 500,
            headers: { 'Content-Type': 'application/json' }
        });
    });
    var error = null;
    if (!response.ok) {
        await response.text().then(text => {
            const data = text && JSON.parse(text);
            error = (data.message) || (data.errors[0]);
        });

        if (error && response.status === 401 && error.detail.includes("Token is Expired")) {
            await handleExpiredTokens();
        }
    }

    return await response;
}

async function handleExpiredTokens() {
    const url = `${baseUrl}/auth/refresh`;
    let refresh = cookieHelper.getRefreshToken();
    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': refresh,
        },
        body: JSON.stringify({role: sessionStorage.getItem("user_role")})
    }
    let response = await fetch(url, requestOptions).catch((error) => {
        cookieHelper.setAuthCookie("");
        return new Response(JSON.stringify({ errors: ['Server Error.'] }), {
            status: 500,
            headers: { 'Content-Type': 'application/json' }
        });
    });
    if (response.ok) {
        await response.text().then(text => {
            const data = text && JSON.parse(text);
            cookieHelper.setAuthCookie(data.id_token);
            if(!!data.refresh_token){
                cookieHelper.setRefreshCookie(data.refresh_token);
            }
        });
    } else {
        // Log out user
        cookieHelper.setAuthCookie("");
    }

    return response;
}
